import PageNav from './PageNav';

export default PageNav;
